import React from 'react';
import { Chip } from '@mui/material';
import { FilterType } from '../../types';
import { useFilter } from '../../FilterContext';

const LegacyFilterChips: React.FC = () => {
    const { filterType, setFilterType } = useFilter();
    const onSelectFilterType = setFilterType;

    return (
        <>
            <Chip
                label="All channels"
                color={filterType === FilterType.All ? 'primary' : 'default'}
                variant={filterType === FilterType.All ? 'solid' : 'outlined'}
                onClick={() => onSelectFilterType(FilterType.All)}
            />
            <Chip
                label="Premium"
                color={
                    filterType === FilterType.Premium ? 'primary' : 'default'
                }
                variant={
                    filterType === FilterType.Premium ? 'solid' : 'outlined'
                }
                onClick={() => onSelectFilterType(FilterType.Premium)}
            />
            <Chip
                label="Free"
                color={filterType === FilterType.Free ? 'primary' : 'default'}
                variant={filterType === FilterType.Free ? 'solid' : 'outlined'}
                onClick={() => onSelectFilterType(FilterType.Free)}
            />
        </>
    );
};

export default LegacyFilterChips;
